import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggerService } from '../services/logger.service';
import { PermissionService } from '../services/permission.service';

/**
 * Guard for cross-organization super-admin-only routes (e.g. the QA
 * subscriptions admin page). Distinct from permissionGuard(), which checks
 * per-org permission keys -- this checks the isSuperAdmin flag directly,
 * since no permission key is "only true for super admins."
 */
export const superAdminGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const logger = inject(LoggerService).getLogger('super-admin-guard');

  if (permissionService.isSuperAdmin()) {
    return true;
  }

  logger.warn('Super admin access denied');
  router.navigate(['/forbidden']);
  return false;
};
